import React, { useState, useEffect, useContext } from 'react';
import ButtonBack from './images/x.png';
import useWeb3 from '../hooks/useSolanaWeb3';
import { toast } from 'react-hot-toast';
import useFetchNfts from '../hooks/useFetchNfts';
import { doc, updateDoc, increment, getDoc } from 'firebase/firestore';
import { db } from '../components/firebaseConfig'; // Make sure the path is correct
import { SolanaContext } from '../contexts/solanaContext.js';

function ConfirmAntfooSpend({ onClose, antFoodFee }) {
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const { handlePremiumANTMint, fetchBlockchainData, fetchPremiumBatchInfo, fetchAllBalances } = useWeb3();
  const { fetchNfts } = useFetchNfts()
  const [index, setIndex] = useState(undefined);
  const { wallet } = useContext(SolanaContext);

  const updateUserNestData = async (userNestId, walletAddress) => {
    // Update the nest's overall points and tasks completed
    const nestRef = doc(db, 'nests', userNestId);
    await updateDoc(nestRef, {
      PTS: increment(10), // Assuming 10 points for Premium ANT
      tasksCompleted: increment(1),
    });
  
    // Update the user's specific information within that nest's users collection
    const userNestRef = doc(db, 'nests', userNestId, 'users', walletAddress);
    await updateDoc(userNestRef, {
      points: increment(10), // Assuming 10 points for Premium ANT
      tasksCompleted: increment(1),
      premiumAntsBought: increment(1),
    });
  };
  
  const updateFirestoreAfterPurchase = async (walletAddress) => {
    try {
      const userRef = doc(db, 'users', walletAddress);
      await updateDoc(userRef, {
        boughtPremiumAnt: true,
      });
      console.log('Firestore updated successfully for:', walletAddress);
    } catch (error) {
      console.error('Error updating Firestore:', error);
    }
  };

  const premiumAntMint = async () => {
    try {
      setLoading(true);
      if (index) {
        await handlePremiumANTMint(index);
        await fetchAllBalances();
        
        const walletAddress = wallet?.publicKey?.toString();
        if (!walletAddress) {
          toast.error("Wallet address not found");
          return;
        }
        
        // Firestore update after successful minting
        await updateFirestoreAfterPurchase(walletAddress);
        const userRef = doc(db, 'users', walletAddress);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists() && userSnap.data().nest) {
          await updateUserNestData(userSnap.data().nest, walletAddress);
        }
        
        await fetchNfts(10); // Fetch NFTs after updating data
        toast.success("PremiumANT Minted Successfully");
        onClose(); // Close the popup or modal
      } else {
        toast.error("No index found for minting");
      }
    } catch (err) {
      console.log("premium ant mint error:", err);
      if (err.data && String(err.data.message).includes("insufficient funds")) {
        toast.error("Insufficient funds");
      } else {
        switch (true) {
          case String(err).includes("User rejected request"):
            toast.error("User rejected request");
            break;
          case String(err).includes("PremiumANT: insufficient balance"):
            toast.error("Insufficient $ANTF balance");
            break;
          case String(err).includes("PremiumANT: mint amount exceeds the maximum supply for this batch"):
            toast.error("Mint amount exceeds the maximum supply for this batch");
            break;
          default:
            toast.error("Something went wrong!");
            break;
        }
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const getPremiumBatchInfo = async() => {
      const data = await fetchPremiumBatchInfo();
      
      setIndex(data.minted + 1);
      
    }
    getPremiumBatchInfo();
  },[])


  return (
    <div className="popup-container">
      <div className="popup">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} alt="Close button" />
        </button>
        <div className="popupinfo-holder" id="stake-amount">
          <h1>CONFIRM SPENDING OF $ANTC</h1>
          <div className="info-box-incubating">
            <p>Note your wallet will be charged {antFoodFee} $ANTF. In exchange you get premium ANT!
            </p>
          </div>
          <button className="buy-button-incubating" onClick={premiumAntMint} disabled={loading}>
            <span>{loading ? "Loading..." : "CONFIRM"}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmAntfooSpend;